<template>
  <i class="workfine-tubiaoji" :class="iconClass"></i>
</template>

<script>
import '@/assets/workfine-tubiaoji/iconfont.css'
export default {
  name: 'icon',
  props: {
    iconId: {
      type: Number,
      default: null
    },
  },
  computed: {
    iconClass() {
      return `workfine-tubiaoji-${this.iconId}`
    }
  }
}
</script>

<style lang="scss">
  .workfine-tubiaoji {
    display: inline-block;
    margin-right: 10px;
  }
</style>